/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Dashboard_BlurbInputs */



/**
* | output |
* | --- |
* | "Welcome to your dashboard, the command center for your AI workspace. Track usage and activity, and jump into projects, spaces, and chats from here." |
*
* @param {Uno_Edu_Intro_Dashboard_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_dashboard_blurb = /** @type {((inputs?: Uno_Edu_Intro_Dashboard_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Dashboard_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Willkommen in Ihrem Dashboard, dem Kontrollzentrum für Ihren KI-Arbeitsbereich. Verfolgen Sie Nutzung und Aktivität und springen Sie von hier aus in Projekte, Spaces und Chats.")
	return /** @type {LocalizedString} */ ("Welcome to your dashboard, the command center for your AI workspace. Track usage and activity, and jump into projects, spaces, and chats from here.")
});